module.exports = __webpack_public_path__ + "img/imageninicio.c6de7d8d.png";